// extracted by mini-css-extract-plugin
export default {"main":"Header_main__P-YzF","title":"Header_title__0ix2c","search":"Header_search__aShcG","tabs":"Header_tabs__vAomK"};